import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { HighlightOffRounded } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';

export default function PlanModal(props) {
  const { t } = useTranslation();
  const { show, onHide, prod } = props;

  const [plan, setplan] = useState({ _id: '' });

  useEffect(() => {
    setplan({ _id: '' });
  }, [show]);

  //   const addToCart = async (e) => {
  //     console.log(products[i]);
  // const index = props.cart?.findIndex(item => item.id === products[i]._id);
  // if (props.prod.current_stock > 0) {
  //     props.decreStock(products[i], products[i].current_stock - 1);
  //     if (props.prod.plan && Date.parse(props.prod.plan.start) <= today && Date.parse(props.prod.plan.end) >= today) {
  //         setShowp(true);
  //         setmyprod(props.prod)
  //     }
  //     if (index >= 0) {
  //         props.alterquantity({id: products[i]._id}, props.cart[index].quantity + 1);
  //     }
  //     else {
  //         props.add({
  //             idx: parseInt(i),
  //             id: products[i]._id,
  //             key: products[i]._id,
  //             upc: products[i]?.upc,
  //             title: products[i].name,
  //             promo: products[i].promo,
  //             price: products[i].price,
  //             discount: products[i].discount ? products[i].discount : 0,
  //             percentage: products[i].percentage,
  //             discountedPrice: products[i].discountedPrice ? products[i].discountedPrice : products[i].price,
  //             image: products[i].productPictures[0],
  //             buyX: products[i].buyX ? products[i].buyX : 0,
  //             quantity: 1,
  //             category: products[i].category,
  //             ingredients: products[i].ingredients,
  //             referTo: products[i].referTo
  //         })
  //     }
  // }
  // }

  const handleClick = () => {
    const index = props.cart?.findIndex((item) => item.id === plan._id);
    if (index >= 0) {
      props.alterquantity({ id: plan._id }, props.cart[index].quantity + 1);
    } else {
      props.add({
        id: plan._id,
        key: plan._id,
        upc: plan?.upc,
        title: plan.name,
        price: plan.price,
        image: plan.productPictures[0],
        discountedPrice: plan.price,
        discount: plan.discount || 0,
        quantity: 1,
        category: plan.category,
        referTo: plan.referTo,
      });
    }
    props.onHide();
  };

  const onChange = (e) => {
    setplan(e);
    console.log(props.cart);
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Body className="ui-bg-color">
        <HighlightOffRounded
          className="close_circle_icon"
          style={{ fontSize: '40px', marginTop: '0px' }}
          onClick={() => {
            props.onHide();
          }}
        />
        <Container>
          <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ marginTop: '20px' }}
          >
            <div className="plan-offer-div d-flex flex-column justify-content-center align-items-center mb-5">
              <div className="ui-font1" style={{ fontSize: '2rem' }}>
                *{t('Special Offer')}
              </div>
              <div
                className="ui-font1"
                style={{
                  paddingLeft: '10px',
                  paddingRight: '10px',
                  fontSize: '1.1rem',
                  textAlign: 'center',
                }}
              >
                {t('Add a data package to your device for a low cost')}
              </div>
            </div>
            <div className="mb-5 d-flex flex-column align-items-start mb-1">
              {prod &&
                prod.plan &&
                prod.plan.plan.map((e, i) => {
                  return (
                    <div key={i} className="mb-1">
                      {/* <div className="d-flex flex-column justify-content-center align-items-center"> */}
                      <div className="d-flex align-items-center justify-content-center">
                        <div className="d-flex align-items-center justify-content-center">
                          <input
                            type="radio"
                            className="plan-radio"
                            id={i}
                            checked={plan && plan._id === e._id}
                            onChange={() => onChange(e)}
                          />{' '}
                        </div>
                        <div className="ui-font1" style={{ margin: 'auto', fontSize: '1.5rem' }}>
                          {e.name}/${e.price}
                        </div>
                      </div>
                    </div>
                    // </div>
                  );
                })}
            </div>
            {plan._id != '' && (
              <div
                className="plan-addtocart-button d-flex justify-content-center"
                style={{
                  width: '200px',
                  cursor: 'pointer',
                }}
                onClick={handleClick}
              >
                {t(`Add to Cart`)}
              </div>
            )}
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
